import ampLogo from '@/assets/integrations/amp.svg'
import amazonQDeveloperLogo from '@/assets/integrations/amazon-q-developer.svg'
import claudeCodeLogo from '@/assets/integrations/claude-code.svg'
import cursorLogo from '@/assets/integrations/cursor.svg'
import geminiCodeAssistLogo from '@/assets/integrations/gemini-code-assist.svg'
import githubCopilotLogo from '@/assets/integrations/github-copilot.svg'
import googleAntigravityLogo from '@/assets/integrations/google-antigravity.svg'
import julesLogo from '@/assets/integrations/jules.svg'
import kiroLogo from '@/assets/integrations/kiro.svg'
import openaiCodexLogo from '@/assets/integrations/openai-codex.svg'
import opencodeLogo from '@/assets/integrations/opencode.svg'
import replitAgentLogo from '@/assets/integrations/replit-agent.svg'
import windsurfLogo from '@/assets/integrations/windsurf.svg'
import zedLogo from '@/assets/integrations/zed.svg'

export interface McpIntegrationBranding {
	logo: string
	brandColor: string
}

const integrationBranding: Record<string, McpIntegrationBranding> = {
	amp: { logo: ampLogo, brandColor: '#005AF0' },
	'amazon-q-developer': { logo: amazonQDeveloperLogo, brandColor: '#FF9900' },
	'claude-code': { logo: claudeCodeLogo, brandColor: '#db7e60' },
	cursor: { logo: cursorLogo, brandColor: '#4A8BFC' },
	'cursor-cli': { logo: cursorLogo, brandColor: '#4A8BFC' },
	'cursor-web': { logo: cursorLogo, brandColor: '#4A8BFC' },
	'gemini-code-assist': { logo: geminiCodeAssistLogo, brandColor: '#8E75B2' },
	'github-copilot': { logo: githubCopilotLogo, brandColor: '#3B82F6' },
	'google-antigravity': { logo: googleAntigravityLogo, brandColor: '#4285F4' },
	jules: { logo: julesLogo, brandColor: '#4285F4' },
	kiro: { logo: kiroLogo, brandColor: '#FF9900' },
	'openai-codex-cli': { logo: openaiCodexLogo, brandColor: '#10A37F' },
	'openai-codex-cloud': { logo: openaiCodexLogo, brandColor: '#10A37F' },
	'openai-codex-desktop': { logo: openaiCodexLogo, brandColor: '#10A37F' },
	opencode: { logo: opencodeLogo, brandColor: '#4B4646' },
	'replit-agent': { logo: replitAgentLogo, brandColor: '#F26207' },
	windsurf: { logo: windsurfLogo, brandColor: '#16A085' },
	zed: { logo: zedLogo, brandColor: '#084CCF' },
}

export function getIntegrationBranding(slug: string): McpIntegrationBranding | null {
	return integrationBranding[slug] ?? null
}
